export default async function guest({ next, store }) {
  const loggedInCheck = window.localStorage.getItem("guest");

  // if LS and the store disagree with each other i.e. user isn't authenticated but the LS thinks there is a user that isn't a guest
  if (loggedInCheck === "isNotGuest" && !store.getters["user/isAuthenticated"]) {
    await store.dispatch("user/fetchUser");
    //they are logged in redirect to homepage
    if (store.getters["user/isAuthenticated"]) {
      next({ name: "search" });
    } else {
      store.dispatch("user/setGuest", { value: "isGuest" });
      next();
    }
  } else {
    next();
  }
}
